<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { supabase } from '@/supabase';

import MultiSelect from 'primevue/multiselect';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Avatar from 'primevue/avatar';
import Panel from 'primevue/panel'
import Dialog from 'primevue/dialog';

const store = useStore();
const estudantes = ref([])
const lembretes = ref([])
const lembretesConcluidos = ref([])
const loadingEstudantes = ref(false)
const visible = ref(false)

const lembrete = ref('')
const lembreteEditado = ref('')
const lembreteId = ref(null)
const estudantesSelecionados = ref([])
const registroAcompanhamento = ref({})

const turma = computed(() => store.state.turma)

onMounted(() => {
    listarEstudantes()
    listarLembretes()
})

async function criarLembrete() {
    if (lembrete.value == '') {
        alert('Por favor, insira um texto para o lembrete.');
        return;
    }

    let lembreteData = null
    if (estudantesSelecionados.value.length > 0) {
        lembreteData = []
        estudantesSelecionados.value.forEach(item => {
            lembreteData.push({
                idDaAula: turma.value.idDaAula,
                status: 1,
                texto: lembrete.value,
                estudante: item
            })
        })
    } else {
        lembreteData = {
            idDaAula: turma.value.idDaAula,
            status: 1,
            texto: lembrete.value
        };
    }

    const { data, error } = await supabase
        .from('lembretes')
        .insert(lembreteData)
        .select()

    if (error) {
        alert('Ocorreu um erro ao criar o lembrete: ' + error.message);
    } else {
        lembrete.value = '';
        estudantesSelecionados.value = [];
        listarLembretes()

    }
}
async function listarLembretes() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('lembretes')
        .select('id, idDaAula, created_at, status, texto, users(id, nome, img), lembretes_acompanhamento(texto, created_at, id)')
        .eq('idDaAula', turma.value.idDaAula)
        .eq('status', 1)
        .order('created_at', { ascending: false })

    if (error) {
        store.dispatch('updateLoading', false)
        alert('Ocorreu um erro ao carregar os lembretes: ' + error.message)
        return
    }
    lembretes.value = data
    store.dispatch('updateLoading', false)
}

async function criarRegistroAcompanhamento(idLembrete) {
    console.log(registroAcompanhamento.value[idLembrete])
    const { data, error } = await supabase
        .from('lembretes_acompanhamento')
        .insert({
            lembrete: idLembrete,
            texto: registroAcompanhamento.value[idLembrete]
        })
        .select()
    const item = lembretes.value.find(item => item.id === idLembrete);
    if (item) {
        item.lembretes_acompanhamento.push(data[0]);
    }

    if (error) {
        alert('Ocorreu um erro ao criar o registro de acompanhamento: ' + error.message);
    } else {
        registroAcompanhamento.value[idLembrete] = '';

    }

}

async function excluirAcompanhamento(id, idLembrete) {
    const { error } = await supabase
        .from('lembretes_acompanhamento')
        .delete()
        .eq('id', id)

    if (error) {
        alert('Ocorreu um erro ao excluir o registro de acompanhamento: ' + error.message)
    }

    const item = lembretes.value.find(item => item.id === idLembrete);
    if (item) {
        let itemAcompanhamento = item.lembretes_acompanhamento.find(item => item.id === id);
        const index = item.lembretes_acompanhamento.findIndex(acomp => acomp.id === id);

        if (index !== -1) {
            item.lembretes_acompanhamento.splice(index, 1);
        }

    }

}

async function listarEstudantes() {
    loadingEstudantes.value = true
    const { data, error } = await supabase
        .from('estudantes_turmas')
        .select('idDaTurma,users(id, nome, img)')
        .eq('idDaTurma', turma.value.idDaTurma)

    if (error) {
        alert('Ocorreu um erro ao carregar os estudantes: ' + error.message)
        return
    }

    let array = []
    data.forEach(item => {
        array.push({ id: item.users.id, nome: item.users.nome, img: item.users.img })
    })
    estudantes.value = array
    loadingEstudantes.value = false
}


function formatarDataAmigavel(dataStr) {
    const opcoes = { day: 'numeric', month: 'long' };
    const data = new Date(dataStr);
    return new Intl.DateTimeFormat('pt-BR', opcoes).format(data);
}

async function excluirLembrete(id, statusLembrete) {
console.log(statusLembrete)
    const { error } = await supabase
        .from('lembretes')
        .delete()
        .eq('id', id)

    if (error) {
        alert('Ocorreu um erro ao excluir o lembrete: ' + error.message);
    } else {
        if (statusLembrete == 'concluido') {
            let index = lembretesConcluidos.value.findIndex(item => item.id === id);
            if (index !== -1) {
                lembretesConcluidos.value.splice(index, 1);
            }
        } else {
            let index = lembretes.value.findIndex(item => item.id === id);
            if (index !== -1) {
                lembretes.value.splice(index, 1);
            }
            
        }
        
    }

}

async function concluirLembrete(id) {
    const { error } = await supabase
        .from('lembretes')
        .update({ status: 2 })
        .eq('id', id)

    if (error) {
        alert('Ocorreu um erro ao atualizar o status do lembrete: ' + error.message);
    } else {
        let index = lembretes.value.findIndex(item => item.id === id);
        if (index !== -1) {
            lembretes.value.splice(index, 1);
        }
    }
}

async function carregarLembretesConcluidos() {
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
        .from('lembretes')
        .select('id, idDaAula, created_at, status, texto, users(id, nome, img), lembretes_acompanhamento(texto, created_at, id)')
        .eq('idDaAula', turma.value.idDaAula)
        .eq('status', 2)
        .order('created_at', { ascending: false })

    if (error) {
        store.dispatch('updateLoading', false)
        alert('Ocorreu um erro ao carregar os lembretes: ' + error.message)
        return
    }
    if(data.length == 0){
      alert('Você não tem nenhum lembrete concluído para exibir')  
    }
    lembretesConcluidos.value = data
    store.dispatch('updateLoading', false)
}

async function editarLembrete(idLembrete, texto) {
    visible.value = true
    lembreteId.value = idLembrete
    lembreteEditado.value = texto

}
async function atualizarLembrete() {
    const { error } = await supabase
        .from('lembretes')
        .update({ texto: lembreteEditado.value })
        .eq('id', lembreteId.value)


    if (error) {
        visible.value = false
        lembreteId.value = null
        alert('Ocorreu um erro ao editar o lembrete: ' + error.message)
        return
    }

    let index = lembretes.value.findIndex(item => item.id == lembreteId.value);
    console.log(index)
    if (index !== -1) {
        lembretes.value[index].texto = lembreteEditado.value
    }
    visible.value = false
    lembreteId.value = null

}
function replaceNewlinesWithHr(text) {
    // Replace all newline characters with '<hr>'
    return text.replace(/\n/g, "<br>");
}

</script>


<template>
    <div class="pt-8 pb-8 surface-50 " style="padding-bottom: 100px">
        <Dialog v-model:visible="visible" modal :style="{ width: '50rem' }"
            :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <div class="flex flex-column gap-3 mt-2">

                <Textarea autoResize autofocus v-model="lembreteEditado" rows="3" cols="30"
                    placeholder="Registre alguma informação sobre a turma ou sobre estudantes específicos para lembrar."
                    class="w-full" />


                <Button label="Salvar" @click="atualizarLembrete"  :disabled="lembreteEditado.trim() == ''" />
            </div>

        </Dialog>
        <div class="container">
            <div class="flex flex-column gap-3">

                <Textarea autoResize v-model="lembrete" rows="3" cols="30"
                    placeholder="Registre alguma informação sobre a turma ou sobre estudantes específicos para lembrar."
                    class="w-full" />

                <MultiSelect v-model="estudantesSelecionados" loadingEstudantes :options="estudantes" optionLabel="nome"
                    optionValue="id" placeholder="Selecione estudantes (opcional)" display="chip" class="w-full">
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <img :alt="slotProps.option.nome" :src="slotProps.option.img" :class="`mr-2 border-circle`"
                                style="width: 18px" />
                            <div>{{ slotProps.option.nome }}</div>
                        </div>
                    </template>
                </MultiSelect>


                <Button label="Adicionar Lembrete" @click="criarLembrete" :disabled="lembrete.trim() == ''" />
            </div>

            <div class="mt-4 flex flex-column gap-3">
                <Panel class="panel-lembrete" v-for="lembrete in lembretes" :key="lembrete.id">
                    <template #header>
                        <div v-if="lembrete.users" class="flex align-items-center gap-2">
                            <Avatar :image="lembrete.users.img" size="small" shape="circle" />
                            <div>
                                <div class="font-bold">{{ lembrete.users.nome }}</div>
                                <div>{{ formatarDataAmigavel(lembrete.created_at) }}</div>
                            </div>
                        </div>
                        <div v-else>
                            <span class="font-bold">{{ formatarDataAmigavel(lembrete.created_at) }}</span>
                        </div>
                    </template>
                    <template #footer>
                        <div>
                            <div class="text-sm flex flex-column gap-2"
                                v-for="acompanhamento in lembrete.lembretes_acompanhamento" :key="acompanhamento.id">
                                <div>
                                    <div class="flex align-items-center justify-content-between mt-2 mb-2">
                                        <div>{{ formatarDataAmigavel(acompanhamento.created_at) }}</div><Button
                                            @click="excluirAcompanhamento(acompanhamento.id, lembrete.id)" text
                                            severity="secondary" icon="pi pi-trash" />
                                    </div>
                                    <div class="lembrete-texto" v-html="replaceNewlinesWithHr(acompanhamento.texto) "></div>

                                </div>
                            </div>
                            <div class="flex  align-items-center justify-content-between gap-3">
                                <Textarea autoResize v-model="registroAcompanhamento[lembrete.id]"
                                    placeholder="Registrar acompanhamento" rows="1" cols="30" class="w-full mt-3" />
                                <Button text class=" mt-3 " icon="pi pi-send"
                                    @click="criarRegistroAcompanhamento(lembrete.id)" />
                            </div>
                        </div>
                    </template>
                    <template #icons>
                        <button v-tooltip.top="'Concluir lembrete'" class="p-panel-header-icon p-link mr-2"
                            @click="concluirLembrete(lembrete.id)">
                            <span class="pi pi-check-circle"></span>
                        </button>
                        <button v-tooltip.top="'Editar lembrete'" class="p-panel-header-icon p-link mr-2"
                            @click="editarLembrete(lembrete.id, lembrete.texto, 'editar')">
                            <span class="pi pi-pencil"></span>
                        </button>
                        <button v-tooltip.top="'Excluir lembrete'" class="p-panel-header-icon p-link mr-2"
                            @click="excluirLembrete(lembrete.id)">
                            <span class="pi pi-trash"></span>
                        </button>


                    </template>

                    <p class="m-0">
                    <div class="lembrete-texto" v-html="replaceNewlinesWithHr(lembrete.texto)"></div>
                    </p>
                </Panel>

            </div>

            <div class="mt-4 flex flex-column gap-3">
                <Button label="Ver lembretes concluídos" class="w-full" severity="secondary"
                    @click="carregarLembretesConcluidos" />
            </div>


            <div class="mt-4 flex flex-column gap-3">
                <Panel toggleable :collapsed="true" class="panel-lembrete" v-for="lembrete in lembretesConcluidos"
                    :key="lembrete.id">
                    <template #header>
                        <div v-if="lembrete.users" class="flex align-items-center gap-2">
                            <Avatar :image="lembrete.users.img" size="small" shape="circle" />
                            <div>
                                <div class="font-bold">{{ lembrete.users.nome }}</div>
                                <div>{{ formatarDataAmigavel(lembrete.created_at) }}</div>
                            </div>
                        </div>
                        <div v-else>
                            <span class="font-bold">{{ formatarDataAmigavel(lembrete.created_at) }}</span>
                        </div>
                    </template>
                    <template #footer>
                        <div>
                            <div class="text-sm flex flex-column gap-2"
                                v-for="acompanhamento in lembrete.lembretes_acompanhamento" :key="acompanhamento.id">
                                <div>
                                    <div class="flex align-items-center justify-content-between mt-2 mb-2">
                                        <div>{{ formatarDataAmigavel(acompanhamento.created_at) }}</div>
                                    </div>
                                    <div class="lembrete-texto" v-html="replaceNewlinesWithHr(lembrete.texto) "></div>

                                </div>
                            </div>

                        </div>
                    </template>
                    <template #icons>
                        <button v-tooltip.top="'Excluir lembrete'" class="p-panel-header-icon p-link mr-2"
                            @click="excluirLembrete(lembrete.id, 'concluido')">
                            <span class="pi pi-trash"></span>
                        </button>
                    </template>
                    <p class="m-0">
                    <div class="lembrete-texto" v-html="replaceNewlinesWithHr(lembrete.texto) "></div>
                    </p>
                </Panel>

            </div>
        </div>
    </div>
</template>

<style >
.panel-lembrete .p-panel-header {
    background-color: #fff
}
.lembrete-texto br{
    content: "";
        display: block;
        margin-top: 10px;
}
</style>